import React, { useEffect, useState } from 'react';

import styles from './Combines.module.scss';

import InfiniteScroll from 'react-infinite-scroll-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLoader } from '@fortawesome/pro-light-svg-icons';

import { useLocation } from 'react-router-dom';

import ProductCard from '../ProductCard/ProductCard';
import useUsers from '../../hooks/useUsers';
import Loader from '../Loader/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { setProducts } from '../../redux/slices/productSlice';
import { productsSelector } from '../../redux/selectors';
function Combines() {
  const { getProducts } = useUsers();

  const [combines, setCombines] = useState([]);
  const [hasMore, setHasMore] = useState(true);

  const [metadata, setMetadata] = useState({
    offset: 0,
    limit: 10,
  });

  const [total, setTotal] = useState(null);

  const [loading, setLoading] = useState(true);

  const { pathname } = useLocation();

  const SEARCH__PRODUCT = 'Kombayn';

  const fetchData = () => {
    getProducts({}, metadata.offset, metadata.limit, SEARCH__PRODUCT).then(
        (data) => {
          if (data.data) {
            setTotal(data.data.total);

            setLoading(false);
            setCombines([...combines, ...data.data.products]);

            setHasMore(false);

            let updOffset = metadata.offset + 10;
            setMetadata({ ...metadata, offset: updOffset });
          }
        }
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (pathname !== '/kombaynlar') {
      getProducts({}, 0, 4, SEARCH__PRODUCT).then((data) => {
        if (data.data) {
          setTotal(data.data.total);

          setLoading(false);
          setCombines(data.data.products);
        }
      });
    }
  }, []);

  const infiniteScrollStyles = {
    position: 'relative',
  };

  const products = useSelector(productsSelector);

  return pathname !== '/kombaynlar' ? (
      <div className={styles.combines__wrapper}>
        {loading ? (
            <div className="loaders">
              <Loader />
              <Loader />
              <Loader />
              <Loader />
            </div>
        ) : (
            <>
              {combines?.map((item) => (
                  <ProductCard
                      key={item.id}
                      id={item.id}
                      products_type="combine"
                      name={item.name}
                      stock_status={item.stock_status}
                      files={item.files}
                      price={item.price}
                      old_price={item.old_price}
                      is_active={item.is_active}
                      navigation={item.navigation}
                      calc_type={item.calc_type}
                      monthly_payment_amount={item?.monthly_payment_amount}
                  />
              ))}
            </>
        )}
      </div>
  ) : (
      <InfiniteScroll
          style={infiniteScrollStyles}
          className={styles.combines__wrapper}
          dataLength={combines?.length}
          next={fetchData}
          hasMore={hasMore}
          loader={
            <div className={styles.infiniteLoader}>
              <FontAwesomeIcon icon={faLoader} />
              <span>Loading...</span>
            </div>
          }
      >
        {loading ? (
            <div className="loaders">
              <Loader />
              <Loader />
              <Loader />
              <Loader />
            </div>
        ) : (
            <>
              {combines.map((product) => (
                  <ProductCard
                      key={product.id}
                      id={product.id}
                      products_type="tractor"
                      name={product.name}
                      stock_status={product.stock_status}
                      files={product.files}
                      price={product.price}
                      old_price={product.old_price}
                      is_active={product.is_active}
                      navigation={product.navigation}
                      calc_type={product.calc_type}
                      monthly_payment_amount={product?.monthly_payment_amount}
                      product={product}
                  />
              ))}
            </>
        )}
      </InfiniteScroll>
  );
}

export default Combines;
